import { Link } from "react-router-dom";
import "./Services.css";

const Services = () => {
  return (
    <section className="services-section">
      <div className="container">
        <h2 className="section-title">Nossos Serviços Jurídicos</h2>
        <p className="section-subtitle">
          Oferecemos uma gama completa de serviços jurídicos com um compromisso
          inabalável com a excelência, integridade e a defesa dos seus
          interesses.
        </p>

        <div className="services-grid">
          {/* Serviço 1 */}
          <div className="service-card">
            <h3 className='titulo'>Divórcio e Dissolução de Uniões</h3>
            <p className="descricao">
              Aconselhamento e representação legal em processos de divórcio,
              consensual ou litigioso, e dissolução de união de facto.
            </p>
          </div>

          {/* Serviço 2 */}
          <div className="service-card">
            <h3 className='titulo'>Regulação das Responsabilidades Parentais</h3>
            <p className="descricao">
              Definição da guarda dos filhos, regulação do convívio (visitas) e
              fixação ou revisão da pensão de alimentos.
            </p>
          </div>

          {/* Serviço 3 */}
          <div className="service-card">
            <h3 className='titulo'>Regimes de Bens e Pactos Antenupciais</h3>
            <p className="descricao">
              Orientação jurídica sobre os regimes de bens do casamento e
              elaboração de convenções antenupciais.
            </p>
          </div>

          {/* Serviço 4 */}
          <div className="service-card">
            <h3 className='titulo'>Reconhecimento e Dissolução de União de Facto</h3>
            <p className="descricao">
              Regularização jurídica de uniões não formalizadas e assistência na
              sua dissolução.
            </p>
          </div>

          {/* Serviço 5 */}
          <div className="service-card">
            <h3 className='titulo'>Adoção e Interdição</h3>
            <p className="descricao">
              Apoio jurídico em processos de adoção, interdição e nomeação de
              curador.
            </p>
          </div>

          {/* Serviço 6 */}
          <div className="service-card">
            <h3 className='titulo'>Testamentos e Planeamento Sucessório</h3>
            <p className="descricao">
              Elaboração de testamentos, doações em vida e organização do
              património com foco em proteção familiar e eficácia sucessória.
            </p>
          </div>

          {/* Serviço 7 */}
          <div className="service-card">
            <h3 className='titulo'>Partilhas e Inventários</h3>
            <p className="descricao">
              Mediação entre herdeiros, organização da partilha de bens e
              condução de processos de inventário, tanto judiciais quanto
              extrajudiciais.
            </p>
          </div>

          {/* Serviço 8 */}
          <div className="service-card">
            <h3 className='titulo'>Contestações de Testamentos</h3>
            <p className="descricao">
              Impugnação de testamentos por vício de forma, incapacidade do
              testador ou outras ilegalidades.
            </p>
          </div>

          {/* Serviço 9 */}
          <div className="service-card">
            <h3 className='titulo'>Heranças Internacionais</h3>
            <p className="descricao">
              Assistência jurídica em partilhas de bens localizados em
              diferentes países e regularização de sucessões transfronteiriças.
            </p>
          </div>

          {/* Serviço 10 */}
          <div className="service-card">
            <h3 className='titulo'>Inventário Judicial e Extrajudicial</h3>
            <p className="descricao">
              Acompanhamento completo em processos de inventário perante o
              tribunal ou por via notarial, incluindo elaboração de peças
              processuais e representação dos interessados.
            </p>
          </div>
        </div>

        <div className="cta">
          <h3>Pronto para dar o próximo passo?</h3>
          <Link to="/contato" className="cta-button">
            Agende sua consulta
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
